import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { Button, FormGroup } from "reactstrap";
import { Loader } from "pickups-ui-library";

const FormNavigation = (props) => {
  const {
    pristine,
    submitting,
    invalid,
    nextStep,
    previousStep,
    nextLabel,
    prevLabel,
    alternateActionLabel,
    alternateAction,
    leaveInitialFlow,
    isDisabled,
    showSkipBtn,
  } = props;

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (submitting) setTimeout(() => setShowLoader(true), 1000);
    else setShowLoader(false);
  }, [submitting]);

  let displayNext = nextLabel ? nextLabel : "Continue";
  let displayPrev = prevLabel ? prevLabel : "Back";

  const handlePreviousClick = () => {
    if (leaveInitialFlow) {
      leaveInitialFlow();
    }
    previousStep();
  };

  // this allows for a isDisabled prop to be passed for dynamic form submission restrictions
  const canSubmit = !(isDisabled || invalid || submitting);

  return (
    <div className={"form-controls"}>
      <div style={{ flex: 1 }}>
        {alternateAction && alternateActionLabel ? (
          <div className="form-alternate-action">
            <a className="pull-right" onClick={alternateAction}>
              {alternateActionLabel}
            </a>
          </div>
        ) : null}
        {previousStep ? (
          <a
            style={{
              margin: "0 20px 0 0",
              color: "#898989",
              cursor: "pointer",
            }}
            onClick={() => handlePreviousClick()}
          >
            {displayPrev}
          </a>
        ) : null}
        {showSkipBtn && (
          <Button type="submit" style={{ marginRight: "1.5rem" }}>
            <span style={{ display: "flex" }}>
              {(showLoader && <Loader />) || "Skip"}
            </span>
          </Button>
        )}
        <Button
          type="submit"
          disabled={!canSubmit}
          className={classnames({ disabled: !canSubmit })}
        >
          <span style={{ display: "flex" }}>
            {(showLoader && <Loader />) || displayNext}
          </span>
        </Button>
      </div>
      {alternateAction && alternateActionLabel ? (
        <div className="form-alternate-action">
          <a className="pull-right" onClick={alternateAction}>
            {alternateActionLabel}
          </a>
        </div>
      ) : null}
    </div>
  );
};

export default FormNavigation;
